import { useMemo } from 'react';
import { OnsiteTemplateThumbnail } from '../../OnsiteTemplateThumbnail';
import { useDisplayWebContent } from './hooks/useDisplayWebContent';

export const DisplayWebContentThumbnail = ({ id }) => {
  const { getTemplate } = useDisplayWebContent();

  const template = useMemo(() => getTemplate(id), [getTemplate, id]);

  const templateId = useMemo(() => template?.id, [template?.id]);
  const supportedLanguage = useMemo(() => template?.supportedLanguage, [template?.supportedLanguage]);

  return <OnsiteTemplateThumbnail templateId={templateId} supportedLanguage={supportedLanguage} channel="onsite" />;
};
